<template>
  <nav-bar title="钢瓶退出" />
  <van-row>
    <van-col span="16"> <cylinder-management /></van-col>
    <van-col span="8">
      <div class="search-checkbox">
        <van-checkbox v-model="isExp" shape="square">是否超期</van-checkbox>
      </div></van-col
    >
  </van-row>
  <van-search
    v-model="words"
    placeholder="钢瓶查询"
    input-align="center"
    @search="onSearch"
  />
  <Content :bottom="76" :top="150" @content-scroll="handleContentScroll">
    <Loading v-if="showLoading" :isLoading="isLoading" @reload="init" />
    <ul class="code-list">
      <van-checkbox-group v-model="checked" ref="checkboxGroup">
        <li v-for="item in list" :key="item.gsId" class="code-list-item">
          <div
            class="code-list-item__title"
            :style="{ color: item.gsStatusStr === '1' ? 'red' : '' }"
            @click="handleCodeClick(item.gsCode)"
          >
            {{ item.gsCode }} {{ item.gsStatusStr === '1' ? '(超期)' : '' }}
          </div>
          <van-checkbox :name="item.gsCode" shape="square" />
        </li>
      </van-checkbox-group>
    </ul>
    <loading-more
      :finished="finished"
      :showLoadingMore="showLoadingMore"
      :loadingFail="loadingFail"
      :list="list"
      @reload="reload()"
    />
  </Content>
  <div v-if="!showLoading" class="btn-conatiner van-hairline--top">
    <van-button
      block
      type="primary"
      native-type="button"
      :loading="btnLoading"
      :disabled="btnLoading"
      loading-text="请稍后..."
      @click="handleSubmitClick"
    >
      退出<span v-show="checked.length">（{{ checked.length }}）</span>
    </van-button>
    <!-- 选择退出原因 -->
    <van-overlay :show="show" @click="show = false" z-index="10">
      <div class="wrapper" v-if="show">
        <div class="block" @click.stop>
          <van-form @submit="onConfirm">
            <Picker
              label="退出原因 "
              :columns="columns"
              :border="false"
              :require="true"
              @confirm-values="(value) => (quitReason = value.dicVal)"
            />
            <div style="margin: 16px">
              <van-button round block type="primary" native-type="submit">
                确认
              </van-button>
            </div>
          </van-form>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { ref, computed, watch } from 'vue'
import { getSelectList } from '@/api/common'
import {
  cylinderExitList,
  cylinderRelationRemoveRef
} from '@/api/cylinderManageUserHome'
import { useLoadingMore } from '@/hooks/useLoadingMore'
import { useStore } from 'vuex'
import { useSubmit } from '@/hooks/useSubmit'
import { useRouter } from 'vue-router'
export default {
  name: 'CylinderSignOut', // 钢瓶退出
  setup() {
    const store = useStore()
    const userId = computed(() => store.state.userInfo.id)
    const companyId = computed(() => store.state.roleInfo.companyId)
    const show = ref(false)
    // 退出原因
    const quitReason = ref('')
    const columns = ref([])
    const getReason = () => {
      getSelectList('30').then((res) => {
        columns.value = res.data
      })
    }
    getReason()
    // 选择钢瓶
    const checked = ref([])
    // 点击钢瓶
    const router = useRouter()
    const handleCodeClick = (id) => {
      router.push(`/cylinderInfo/${id}`)
    }
    // 钢瓶退出
    const btnLoading = ref(false)
    const handleSubmitClick = () => {
      if (!checked.value.length) {
        Toast('请选择钢瓶')
      } else {
        show.value = true
      }
    }

    // base
    const isExp = ref(false)
    const words = ref('')
    const searchWord = ref('') // 搜索关键词
    const data = useLoadingMore(cylinderExitList)
    const { getList, list, finished, loadingFail, pageParams } = data

    // 初始化list
    const init = () => {
      list.value = []
      pageParams.gsStatus = 5
      pageParams.page = 1
      pageParams.gsCode = searchWord.value
      pageParams.isExp = isExp.value
      pageParams.companyId = companyId.value
      finished.value = false
      loadingFail.value = false
      checked.value = []
      getList()
    }
    watch(isExp, () => {
      init()
    })
    init()

    // search

    const onSearch = (value) => {
      searchWord.value = value
      init()
      words.value = ''
    }

    const loading = ref(false)
    const onConfirm = () => {
      show.value = false
      const params = {
        gsCodes: checked.value,
        operatorId: userId.value,
        quitReason: quitReason.value
      }
      const { onSubmit, loading } = useSubmit(
        cylinderRelationRemoveRef,
        params,
        () => {
          init()
        }
      )
      watch(loading, (val) => {
        btnLoading.value = val
      })
      onSubmit()
    }
    return {
      ...data,
      words,
      onSearch,
      checked,
      handleSubmitClick,
      handleCodeClick,
      loading,
      btnLoading,
      companyId,
      show,
      onConfirm,
      columns,
      quitReason,
      isExp,
      init
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  padding: 20px;
  background-color: #fff;
}
.form ::v-deep(.van-cell) {
  padding-top: 0;
}
.van-search {
  padding: 0 16px 16px 16px;
}
.search-checkbox {
  font-size: 14px;
  padding: 16px 0;
}
.code-list {
  padding: 16px 16px 0 16px;
  .code-list-item {
    padding: 10px 16px;
    font-size: 16px;
    background-color: #fff;
    display: flex;
    align-items: center;
    box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px,
      rgba(9, 30, 66, 0.08) 0px 0px 0px 1px;
    margin-bottom: 16px;
    color: #666;
    &__title {
      flex: 1;
      margin-right: 10px;
    }
  }
}
.btn-conatiner {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
}
</style>
